import { useEffect } from 'react';
import { ClientFlags, OnboardingTrialStepsType } from '@sdk/authentication/types';
import { SHIFT } from '@sdk/schedule/constants';

import type { Event } from '../onboardingChecklist.types';
import isStepCompleted from '../helpers/isStepCompleted';
import { EventStatus } from '../onboardingChecklist.types';

import type { CompleteStep } from './useCompleteStep';

type Props = {
  availableSteps: OnboardingTrialStepsType[];
  completeStep: CompleteStep;
  clientFlags: ClientFlags;
  allEvents: Event[];
};
const useAutocompletePublishScheduleStep = ({
  availableSteps,
  completeStep,
  clientFlags,
  allEvents,
}: Props) => {
  useEffect(() => {
    if (!clientFlags) {
      // if we don't have client flags at all we're not ready to mark it completed, waiting for them to load.
      return;
    }

    if (isStepCompleted(clientFlags, OnboardingTrialStepsType.publishSchedule)) {
      // step was completed before, no need to proceed further
      return;
    }

    const hasShiftPublished = allEvents.find(
      ({ type, status }) => type === SHIFT && status === EventStatus.published
    );

    if (hasShiftPublished) {
      completeStep(OnboardingTrialStepsType.publishSchedule, availableSteps);
    }
  }, [allEvents, availableSteps, clientFlags, completeStep]);
  return null;
};

export default useAutocompletePublishScheduleStep;
